import type { LucideIcon } from "lucide-react";
import {
  Anchor,
  BarChart3,
  Bell,
  BookOpen,
  Boxes,
  Briefcase,
  Building2,
  Calculator,
  Calendar,
  Camera,
  ClipboardCheck,
  Clock,
  Cpu,
  Database,
  Droplets,
  Factory,
  FileText,
  Flag,
  FlaskConical,
  Gauge,
  Globe,
  Hammer,
  Headphones,
  Heart,
  Home,
  Inbox,
  KeyRound,
  Layers,
  Library,
  Lightbulb,
  Link2,
  Map,
  Megaphone,
  Microscope,
  Network,
  Package,
  PackageSearch,
  Pencil,
  Phone,
  Plug,
  Printer,
  Radio,
  Receipt,
  Recycle,
  Rocket,
  ScanLine,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Siren,
  Sparkles,
  Star,
  Tags,
  Thermometer,
  Truck,
  Users,
  Warehouse,
  Wifi,
  Wrench,
  Zap,
} from "lucide-react";

/** Keys stored on module navigation groups. The picker shows the glyph, not the key. */
export const MODULE_NAV_ICONS: Record<string, LucideIcon> = {
  packages: PackageSearch,
  chart: BarChart3,
  factory: Factory,
  boxes: Boxes,
  shield: ShieldCheck,
  clipboard: ClipboardCheck,
  cart: ShoppingCart,
  people: Users,
  truck: Truck,
  calendar: Calendar,
  tags: Tags,
  wrench: Wrench,
  warehouse: Warehouse,
  document: FileText,
  radio: Radio,
  calculator: Calculator,
  anchor: Anchor,
  bell: Bell,
  book: BookOpen,
  briefcase: Briefcase,
  building: Building2,
  camera: Camera,
  clock: Clock,
  cpu: Cpu,
  database: Database,
  droplets: Droplets,
  flag: Flag,
  flask: FlaskConical,
  gauge: Gauge,
  globe: Globe,
  hammer: Hammer,
  headphones: Headphones,
  heart: Heart,
  home: Home,
  inbox: Inbox,
  key: KeyRound,
  layers: Layers,
  library: Library,
  lightbulb: Lightbulb,
  link: Link2,
  map: Map,
  megaphone: Megaphone,
  microscope: Microscope,
  network: Network,
  package: Package,
  pencil: Pencil,
  phone: Phone,
  plug: Plug,
  printer: Printer,
  receipt: Receipt,
  recycle: Recycle,
  rocket: Rocket,
  scan: ScanLine,
  settings: Settings,
  siren: Siren,
  sparkles: Sparkles,
  star: Star,
  thermometer: Thermometer,
  wifi: Wifi,
  zap: Zap,
};

export const MODULE_NAV_ICON_KEYS = Object.keys(MODULE_NAV_ICONS);

export function moduleNavIcon(name: string): LucideIcon {
  return MODULE_NAV_ICONS[name] ?? Boxes;
}
